import { Component } from 'react';

export default class Calendly extends Component {
    componentDidMount() {
        const head = document.querySelector('head');
        const script = document.createElement('script');
        script.setAttribute('src', 'https://assets.calendly.com/assets/external/widget.js');
        script.setAttribute('id', 'calendly-modal');
        head.appendChild(script);
    }

    componentWillUnmount() {
        const script = document.getElementById('calendly-modal');
        script.parentNode.removeChild(script);
    }

    render() {
        return (
            <div>
                <div id="schedule_form">
                    <div
                        className="calendly-inline-widget"
                        data-url={process.env.CALENDLY_URL}
                        style={{ minWidth: '320px', height: '580px' }}
                    />
                </div>
            </div>
        );
    }
}
